module.exports = __webpack_public_path__ + "static/jon-a125eb8179c86b97682761131e43b8ef.jpg";